import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { NewIconService } from '@shared/domain/new-icon-service';

export const iconInitializerProvider: EnvironmentProviders = provideAppInitializer(() => {
  inject(NewIconService);
  return Promise.resolve(true);
});
